// ✅ Responsive & Polished HomePage Component

import React, { useEffect } from "react";
import MainCarosel from "../../Components/HomeCarosel/MainCarosel";
import HomeSectionCarosel from "../../Components/HomeSectionCarosel/HomeSectionCarosel";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategory } from "../../State/Category/Action";
import Loader from "../../Components/Loader/Loader";
import { getAllProducts } from "../../State/Product/Action";
import HomeSectionGrid from "../../Components/Home/HomeSectionGrid";
import PopularStyles from "../../Components/PopulatStyle/PopularStyles";
import ShopByCategory from "../../Components/Home/ShopByCategory";
import OurCollections from "../../Components/Home/OurCollections";
import BlogPage from "../../Components/Home/BlogPage";
import ReviewSection from "../../Components/Home/ReviewSection";
import SubscribeBanner from "../../Components/Home/SubscribeBanner";
import { getAllDesignerDiscountBanners } from './../../State/DesignerDiscountBanner/Action';

const HomePage = () => {
  const dispatch = useDispatch();
  const publicCategory = useSelector((state) => state.publicCategory);
  const publicDesignerDiscountBanner = useSelector((state) => state.publicDesignerDiscountBanner);
  const products = useSelector((state) => state.products);

  useEffect(() => {
    dispatch(getAllCategory());
    dispatch(getAllProducts());
    dispatch(getAllDesignerDiscountBanners());
  }, [dispatch]);

  return products.loading ? (
    <Loader />
  ) : (
    <div className="overflow-x-hidden bg-white">
      {/* Main Carousel with Header */}
      <MainCarosel />

      {/* Featured Categories */}
      <ShopByCategory publicCategory={publicCategory} designerDiscount={publicDesignerDiscountBanner} products={products.products?.response} />

      {/* New Arrivals Section */}
      <HomeSectionGrid
        title="New Arrivals"
        viewAllLink="/new-arrivals"
        products={products.products?.response}
      />

      {/* Our Collections */}
      <OurCollections />

      {/* Trending Now Section */}
      <HomeSectionGrid
        title="Trending Now"
        viewAllLink="/trending"
        products={products.products?.response}
      />

      {/* Popular Styles */}
      <PopularStyles categories={publicCategory} products={products} />

      {/* Category-specific Carousels */}
      {publicCategory?.categories?.response?.map((category) => (
        <HomeSectionCarosel
          key={category.id}
          sectionName={category.name}
          products={products.products?.response}
        />
      ))}

      {/* Blog Section */}
      <BlogPage />

      {/* Reviews Section */}
      <ReviewSection />

      <SubscribeBanner />
    </div>
  );
};

export default HomePage;
